import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { NgClass } from '@angular/common'
import { ProfileModel } from '../../../core/models/profile.model'
import { animate, state, style, transition, trigger } from '@angular/animations'
import { PermissionService } from '../../../core/services/permission/permission.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'

@Component({
  selector: 'table-list-permission',
  imports: [MatTableModule, MatIcon, NgClass],
  templateUrl: './table-list-permission.component.html',
  styleUrl: './table-list-permission.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ),
    ]),
  ],
  providers: [PermissionService],
})
export class TableListPermissionComponent implements OnInit, OnChanges {
  constructor(
    private permissionService: PermissionService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Input() profile: ProfileModel = new ProfileModel()
  @Output() refreshList = new EventEmitter()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()
  expandedElement: any | null = null

  ngOnInit() {
    this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
    this.displayedColumns.push('expand')
    this.tableSource = new MatTableDataSource<any>(this.dataSource)
    this.updateTableDataSource()
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  updatePermission(element: any) {
    const model = this.createModel(element)
    if (element.permitido == 'S') {
      this.permissionService.unassignProfilePermission(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.refreshList.emit(true)
        },
        error: (err: ErrorRequestModel) => {
          this.snackbar.errorRequest(err)
        },
        complete: () => {},
      })
    } else {
      this.permissionService.assignProfilePermission(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.refreshList.emit(true)
        },
        error: (err: ErrorRequestModel) => {
          this.snackbar.errorRequest(err)
        },
        complete: () => {},
      })
    }
  }

  createModel(element: any) {
    return {
      perfilId: element.perfilId,
      endPointId: element.endpointId,
    }
  }
}
